import { IStackStyles, Stack } from "@fluentui/react";
import React from "react";

interface CallWithSidepaneLayoutProps {
    children: React.ReactNode;
}

export const ActiveElementAndVideoGalleryLayout: React.FC<CallWithSidepaneLayoutProps> = ({
    children,
}): JSX.Element => {

    const containerStyles: IStackStyles = {
        root: {
            width: '100%',
            height: '100%',

            display: 'flex',
            flexFlow: 'column',
            position: 'relative',
            gap: '10px',

            'app-svg-canvas': {
                width: '100%',
                height: '100%',
                display: 'contents',
            },

            '.image-wrapper': {
                width: '100%'
            },
        },
    };

    return (
        <Stack styles={containerStyles}>
            {children}
        </Stack>
    );
};
